import { Component, Input } from '@angular/core';
import { BIModulesService } from '../../bi-modules.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { GridLayoutComponent } from '@progress/kendo-angular-layout';
@Component({
    selector: 'BI-grid-layout',
    templateUrl: './bi-grid-layout.component.html',
    styleUrls: ['./bi-grid-layout.component.scss']
})
export class BIGridLayoutComponent extends GridLayoutComponent {
   
}
